<template>
	<div class="imc_auth_block">
		<div id="imc_auther" class="">

			<div class="component-wrapper" >
				<div class="wrapper" v-bind:class="[show ? 'activeClass' : '']">
					<div class="preload"></div>
					<div class="placeholder"></div>

					<transition name="trial" appear>
						<div class="content">
							<div class="form-wrapper image-after-login">
								<div class="flip-img-wrapper mt-3 mb-3">
									<transition name="fade-profile-pic">
										<icon v-if="!has_pre" class="user-icon image-after-login " name="user-circle-o"></icon>
										<img v-else :src="pre_user.medium_img" class="img-responsive rounded-circle img-thumbnail user-profile text-center" alt="thumbnail">
									</transition>
								</div>
							</div>

							<div class="form-wrapper image-after-login">
								<form class="animate-form">
									<div id="panel-12" class="panel shadow">
										<div class="panel-hdr">
											<h2>Авторизація<span class="fw-300"><i><sup>ІМК портал</sup></i></span></h2>
											<div class="panel-toolbar"></div>
										</div>

										<div class="panel-container show">
											<div class="panel-content">

												<div class="panel-tag  fs-xl">
													Для того щоб авторизуватися введiть Вашi данi (Домен\Користувач) - Наприклад
													IMC\admin Так як на ПК
												</div>

												<b-input-group size="lg" class="mb-3" :prepend=this.current_srv.human_name_ua>
													<b-form-input
														size="lg"
														id="input-live"
														v-model="user.name"
														:state=is_user_valid
														aria-describedby="input-live-help input-live-feedback"
														placeholder="Ваш логін:"
														trim
													></b-form-input>
												</b-input-group>



												<b-input-group size="lg" class="mb-2">
													<b-input-group-prepend>
                                                        <span class="input-group-text">
                                                            <i class="fal fa-unlock-alt fs-xl"></i>
                                                        </span>
													</b-input-group-prepend>

													<b-form-input
														size="lg"
														placeholder="Ваш пароль:"
														id="input-live_psw"
														v-model="user.password"
														type="password" >
													</b-form-input>
												</b-input-group>


												<div id="form-login-submit" class="control-group">
													<div class="controls text-right">

														<button class="btn   btn-lg  mt-3 mb-3 imc_succ " :class="{
                                                            'btn-success' : is_user_valid,
                                                            'btn-outline-warning' : !is_user_valid
                                                        }" v-on:click.prevent="make_auth">
															<span class="fal fal fa-check mr-1" v-if="is_user_valid"></span>
															<span class="fal fa-exclamation-triangle mr-1" v-if="!is_user_valid"></span>
															Авторизація
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</transition>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import 'vue-awesome/icons/user-o';
import 'vue-awesome/icons/user-circle-o';
import Icon from 'vue-awesome/components/Icon';

export default {
	name: "imc_auth",

	components: {
		Icon,
	},

	data() {
		return {


			show: false,

			imc_srvs: [],

			pre_user : null,

			user: {
				name: "",
				password: ""
			},


			show_splash: false,
			logoName: ['І', 'Н', 'О', 'В', 'А', 'Ц', 'I', 'Ї', "   ", 'М', 'Е', 'Н', 'Е', 'Д', 'Ж', 'М', 'Е', 'Н', 'Т', "  ", 'К', 'О', 'М', 'А', 'Н', 'Д', 'А']
		}
	},

	created() {
		this.load_srv_list();
	},

	destroy() {

	},

	methods: {

		async load_srv_list() {
			await axios.get('/api/region_list'
			).then(({data}) => {
				if(data.status == "operation_success") {
					this.imc_srvs = data.data;
				}
			}).catch(err => {

			});
		},

		async load_user_info () {
			await axios.post('/api/user_image',{
					"user": {
						srv : this.current_srv.id,
						user_name : this.current_name
					},
				}
			).then(({data}) => {
				if(data.status == "operation_success") {
					this.pre_user = data.message;
				}
			}).catch(err => {

			});
		},

		leavesplash() {
			this.show_splash = false;
		},

		async make_auth() {

			IMC_CORE.showloading()
			await axios.post('/api/make_auth', {
					"user": this.user.name,
					"password": this.user.password,
				}
			).then(({data}) => {

				IMC_CORE.hideloading();
				if (data.status == "operation_success") {
					window.location.reload();
				} else {
					EventBus.$emit('show_toast', {
						err: 'Авторизвцію відхилено !',
						type: "danger",
						title: 'Перевірте ваші дані, та спробуйте ще раз'
					})
				}

			}).catch(err => {
				IMC_CORE.hideloading();
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
			});
		},

		onSubmit() {

		},
	},

	computed: {
		is_user_valid() {
			if (this.has_srv && this.current_name != null && this.current_name.length > 2) {
				this.load_user_info();
				return true;
			}

			return false;
		},

		has_srv() {
			return this.current_srv_str != null;

		},

		has_pre() {
			if(this.is_user_valid && this.pre_user != null) {
				return true;
			}

			return false;
		},

		current_srv_str() {
			if (this.user.name.length > 0) {
				let expl = this.user.name.split("\\");
				if (expl.length == 2) {
					return expl[0].toUpperCase();
				}
			}
			return null;
		},

		current_name() {
			if (this.user.name.length > 0) {
				let expl = this.user.name.split("\\");
				if (expl.length == 2) {
					return expl[1].toLowerCase();
				}
			}
			return null;
		},

		current_srv() {

			let srv_result = {
				human_name_ua: " -- ",
				status: "no_status",
				id : 0,
			};

			if (this.has_srv && this.imc_srvs.length > 0) {
				this.imc_srvs.map(srv => {
					if (srv.wins_name.toUpperCase() === this.current_srv_str) {
						srv_result = srv;
					}
				});
			}
			return srv_result;
		}
	},


}
</script>

<style scoped>
#imc_auther {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	background-image: url("/templates/imc_docs/css/i/bg-home-news.png");
	color: #2c3e50;
	padding: 5%;
	background-repeat: no-repeat;
	box-sizing: border-box;
	height: 100vh;
	width: 100vw;
	background-size: cover;
	filter: grayscale(30%);
}

.component-wrapper {
	/* box-shadow: 5px 5px 5px 5px rgba(0,0,0,0.2);*/
	height: 100%;
	background: transparent;
	overflow: hidden;
}


</style>
